import type { IStudio } from "../../screens/Dashboard/SubComponents/Studio/interfaces/Studio.interface";

class AdapterModel {
  private Model!: IStudio;

  constructor(model: IStudio) {
    this.Model = model;
  }

  async setHardware() {}

  getModel() {
    return this.Model;
  }
}

export default AdapterModel;
